
import { mapGetters } from "vuex";
export default {
	components: {},
	data() {
		return {
			load: false,
			aboutContent: [
				// {
				// 	title: 'Коротко о главном',
				// 	text: 'В «стенах» нашего автоцентра собраны тысячи подержанных автомобилей, прошедших техническую и юридическую экспертизу. Проверенные временем, опытные автодилеры формируют каталог AUTO EXPERT, объединяя сотни автомобилей на одной площадке. Это удобно покупателям — тот случай, когда огромный выбор непременно переходит в качественную покупку.',
				// 	icon: require('~/assets/icons/ab1.svg'),
				// 	svg: 'ab1'
				// },
				// {
				// 	title: 'Почему мы?',
				// 	text: 'Что делает нас успешнее и прогрессивнее? Это уникальность и продуманность автопарка – у нас собраны наиболее востребованные и удачные модели самых разнообразных марок. Проверка отдельно взятой модели начинается на этапе ее закупки и затем — продолжается во время предпродажной подготовки. Мы разработали современный портал, на котором удобно искать автомобиль своей мечты — как с ПК, так и с мобильного устройства.',
				// 	icon: require('~/assets/icons/ab2.svg'),
				// 	svg: 'ab2'
				// },
				// {
				// 	title: 'Наши принципы',
				// 	text: 'Каждый день мы стремимся сделать покупку авто безопасной, цивилизованной и доступной, что и стало визитной карточкой AUTO EXPERT. Выгодный автокредит, детальная информация о товаре, гарантия и подарки — то, ради чего люди приходят на наш автопортал. Мы сформировали культурный б/у-сегмент в сфере автоторговли и не собираемся останавливаться на достигнутом.',
				// 	icon: require('~/assets/icons/ab3.svg'),
				// 	svg: 'ab3'
				// },
				{
					title: 'Почему мы?',
					text: `<p>В автопарке нашего автосалона мы собрали множество автомобилей с пробегом, которые прошли техническую и юридическую экспертизу.
							Проверка каждого автомобиля начинается с этапа закупки и продолжается во время предпродажной подготовки.
							<p>В «AUTO EXPERT» представлены автомобили более 40 марок, что позволит Вам найти подходящий вариант в стенах одного автосалона.
							Мы создали комфортные и доступные условия для своих покупателей, позволяющие безопасно совершить покупку.
							Выгодные кредитные условия, подробная информация об автомобилях, техническая гарантия и подарки -  то, ради чего люди приходят в наш автосалон.
							</p>
							<p>Ждем Вас в «AUTO EXPERT»!</p>`,
					icon: require('~/assets/icons/ab2.svg'),
					svg: 'ab3'
				},
			]
		}
	},
	props: {
		pageTitle: String
	},
	computed: {
		...mapGetters({
			settings: 'settings/settings/settings',
			offers: 'catalog/catalog-cars/offers',
			loading: 'catalog/catalog-cars/loading'
		}),
		offers_list() {
			if (this.offers.data)
				return this.offers.data
		}
	},
	mounted() {
		setTimeout(() => {
			this.load = true
		}, 400)
	}

}
